import React, { useContext } from 'react'
import { ContentInner } from '../../layout/Content'
import StockOutItemInnerStyle from './css/StockOutItemInnerStyle'
import PrinterSettingsStyle from '../../../css/PrinterSettingsStyle'
import { stockOutItemControllerContext } from './StockOutItemController'

function StockOutItemInner() {
  const stockOutItemController = useContext(stockOutItemControllerContext)
  const { stockOutItem } = stockOutItemController
  return (
    <ContentInner>
      <div className='stockout-wrapper '>
        <div className='stock-out-item-container printable'>
          <div className='stock-out-header-container'>
            <label>Stock Out - {stockOutItem._id.toUpperCase()}</label>
          </div>
          <div className='stock-out-header-details-container'>
            <div className='fields-group-container' id='group-1-fields-container'>
              {
                (stockOutItem.source_warehouse) ?
                <div className='field-group' id='source-warehouse-group'>
                  <label>Source Warehouse</label>
                  <p>{stockOutItem.source_warehouse.name}</p>
                </div>
                : null
              }
              {
                (stockOutItem.dest_warehouse) ?
                <div className='field-group' id='source-warehouse-group'>
                  <label>Destination Warehouse</label>
                  <p>{stockOutItem.dest_warehouse.name}</p>
                </div>
                : null
              }
              <div className='field-group' id='date-time-created-group'>
                <label>Date Time Created</label>
                <p>{new Date(stockOutItem.date_time_created).toLocaleString("en-us")} {stockOutItem.client_timezone}</p>
              </div>
              <div className='field-group' id='received_by-group'>
                <label>Prepared By</label>
                <p>{stockOutItem.prepared_by}</p>
              </div>
            </div>
            <div className='fields-group-container' id='group-2-fields-container'>
              <div className='field-group' id='reference_code-group'>
                <label>Reference</label>
                <p>{stockOutItem.reference_code}</p>
              </div>
              <div className='field-group' id='date-received-group'>
                <label>Date Released</label>
                <p style = {{textAlign: "left"}}>{new Date(stockOutItem.date_released).toLocaleString('en-us', { timeZone: stockOutItem.client_timezone }).split(',')[0]} { stockOutItem.client_timezone }</p>
              </div>
              <div className='field-group' id='remarks-group'>
                <label>Remarks</label>
                <p>{stockOutItem.remarks}</p>
              </div>
              <div className='field-group' id='status-group'>
                <label>Status</label>
                <p>{stockOutItem.status}</p>
              </div>
            </div>
          </div>
          <table className='item-details-table striped-table'>
            <thead>
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Unit</th>
                <th style={{textAlign: 'center'}}>Quantity</th>
                <th>Remarks</th>
                {
                  (stockOutItem.status === 'Posted') ?
                    <th style={{textAlign: 'center'}}>Status</th>
                  : null
                }
              </tr>
            </thead>
            {
              stockOutItem.item_details.map((item_detail, index) => (
                <tbody key={index}>
                  <tr>
                    <td>{index+1}</td>
                    <td>
                      <div className='item-name'>{item_detail.name}</div>
                      <div
                        style={{display: (item_detail.expiration_date) ? 'block' : 'none'}}
                        className='expiration-date-container'>
                        Expiration Date:&nbsp; <span className='expiration-date'>{item_detail.expiration_date}</span>
                      </div>
                    </td>
                    <td>{item_detail.unit}</td>
                    <td style={{textAlign: 'center'}}>{item_detail.quantity}</td>
                    <td>{item_detail.remarks}</td>
                    {
                      (stockOutItem.status === 'Posted') ?
                        <td style={{textAlign: 'center'}}>
                          {
                            (item_detail.exist && !item_detail.neg_qty)
                            ? <span style={{color: 'blue'}}>OK</span>
                            : <span style={{color: 'red'}}>Failed</span>
                          }
                        </td>
                      : null
                    }
                  </tr>
                </tbody>
              ))
            }
          </table>
        </div>
        <div className='log-container'>
          <div className='created-by'>
            Created by {stockOutItem.log.created_by.name} on {`${new Date(stockOutItem.date_time_created).toLocaleString("en-us", { timeZone: stockOutItem.client_timezone })} ${ stockOutItem.client_timezone }`}
          </div>
          <div className='last-modified-by'>
            Last modified by {stockOutItem.log.last_modified_by.name} on {`${new Date(stockOutItem.date_time_modified).toLocaleString("en-us", { timeZone: stockOutItem.client_timezone })} ${ stockOutItem.client_timezone }`}
          </div>
        </div>
        <StockOutItemInnerStyle />
        { <PrinterSettingsStyle paperWidth='8.5inch'/> }
      </div>
    </ContentInner>
  )
}

export default React.memo(StockOutItemInner)
